import Tone from 'tone';

const defaultOptions = {
    baseUrl: '/samples/',
    timeout: 60000,
};

export default class SampleLibrary {
    constructor(options = {}) {
        this.options = Object.assign({}, defaultOptions, options);
    }

    async loadInstrument(instrument) {
        if (!(instrument in this.options.instruments)) {
            throw new Error(`Samples for instrument '${instrument}' not registered`);
        }
        const samples = {};

        const notes = this.options.instruments[instrument];
        Object.keys(notes).forEach((note) => {
            const path = notes[note];
            samples[note] = this.options.baseUrl + '/' + instrument + '/' + path;
        });

        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => {
                reject(`Timeout for loading samples for instrument '${instrument}' exceeded`);
            }, this.options.timeout);

            const sampler = new Tone.Sampler(samples, () => {
                clearTimeout(timer);
                resolve(sampler);
            });
        });
    }
}
